// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z_Ng","controls":"styles_controls__26rAn","charLimit":"styles_charLimit__Y2v_V","input":"styles_input__2Xn-e","send":"styles_send__3_xm9"};